module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"relatedTopics":"Verwandte Themen"},"en":{"relatedTopics":"Related Topics"}}')
  delete Component.options._Ctor
}
